// public/scripts/freelancer-register.js
import { BASE_URL } from "../scripts/config/baseURL.js";
import { showSpinner, hideSpinner } from "../scripts/utils/spinner.js";

console.log("[freelancer-register] script loaded");
console.log("[freelancer-register] Using BASE_URL:", BASE_URL);

// Wait until DOM ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initFreelancerRegistration);
} else {
	initFreelancerRegistration();
}

function initFreelancerRegistration() {
	console.log("[freelancer-register] Initializing form...");

	const form = document.getElementById("freelancerForm");
	let errorDiv = document.getElementById("errorContainer");

	if (!form) {
		console.warn("⚠️ freelancerForm not found in DOM");
		return;
	}

	// Ensure we have a visible error container
	if (!errorDiv) {
		errorDiv = createErrorDiv(form);
	}

	const submitBtn = form.querySelector("button[type='submit']") || form.querySelector("button");
	if (!submitBtn) {
		console.warn("⚠️ Submit button not found in form");
	}

	console.log("✅ Freelancer form ready and handler attached");

	form.addEventListener("submit", (e) => handleFormSubmit(e, form, errorDiv, submitBtn));
}

function createErrorDiv(form) {
	const div = document.createElement("div");
	div.classList.add("text-red-600", "text-sm", "space-y-1", "mt-2");
	form.parentNode.insertBefore(div, form.nextSibling);
	return div;
}

function handleFormSubmit(e, form, errorDiv, submitBtn) {
	e.preventDefault();
	e.stopPropagation();
	errorDiv.innerHTML = "";

	const payload = extractFormData(form);
	const validationErrors = validateFormData(payload);

	if (validationErrors.length > 0) {
		displayErrors(errorDiv, validationErrors);
		return;
	}

	registerFreelancer(payload, form, errorDiv, submitBtn);
}

function extractFormData(form) {
	return {
		name: form.name?.value?.trim() || "",
		email: form.email?.value?.trim() || "",
		phone: form.phone?.value?.trim() || "",
		password: form.password?.value || "",
		confirmPassword: form.confirmPassword?.value || "",
	};
}

function validateFormData({ name, email, phone, password, confirmPassword }) {
	const errors = [];

	if (name.length < 3) errors.push("Name must be at least 3 characters.");
	if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.push("Invalid email format.");
	if (!/^[0-9]{10,15}$/.test(phone)) errors.push("Phone must be 10–15 digits.");
	if (password.length < 6) errors.push("Password must be at least 6 characters.");
	if (!confirmPassword) errors.push("Confirm Password is required.");
	if (password !== confirmPassword) errors.push("Passwords do not match.");

	return errors;
}

function displayErrors(errorDiv, messages) {
	errorDiv.innerHTML = messages.map((e) => `<div>• ${e}</div>`).join("");
}

async function registerFreelancer(payload, form, errorDiv, submitBtn) {
	try {
		showSpinner(submitBtn, "Registering...");

		const res = await fetch(`${BASE_URL}/auth/registration/freelancer`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(payload),
		});

		const data = await res.json();

		if (!res.ok) {
			const serverErrors = extractServerErrors(data);
			displayErrors(errorDiv, serverErrors);
			return;
		}

		console.log("✅ Registered successfully!");
		form.reset();
		window.location.href = "/app/pages/login.html";
	} catch (err) {
		console.error("❌ API error", err);
		displayErrors(errorDiv, [`❌ ${err.message}`]);
	} finally {
		hideSpinner(submitBtn);
	}
}

function extractServerErrors(data) {
	const serverErrors = new Set();

	if (typeof data.message === "string") {
		const msg = data.message.trim();
		const isSafe =
			msg.length < 200 &&
			!msg.toLowerCase().includes("enoent") &&
			!msg.toLowerCase().includes("file") &&
			!msg.toLowerCase().includes("directory");
		serverErrors.add(isSafe ? msg : "Something went wrong. Please try again later.");
	}

	if (Array.isArray(data.errors)) {
		data.errors.forEach((e) => {
			if (typeof e.message === "string" && e.message.trim().length > 0) {
				serverErrors.add(e.message.trim());
			}
		});
	}

	if (serverErrors.size === 0) {
		serverErrors.add("Something went wrong. Please try again later.");
	}

	return [...serverErrors];
}
